import type { ComponentType } from 'react';
import { Panels, Splash, StoreListing, Submitting, Testing } from './content/on-mogzo';
import { CliCommands, Limits, Troubleshooting } from './content/reference';
import {
  Achievements,
  CloudSaves,
  GameData,
  Leaderboards,
  LiveEvents,
  Multiplayer,
  RemoteConfig,
  Sdk,
} from './content/services';
import { AiTools, FirstGame, Install, Introduction, Manifest } from './content/start';

export interface DocPage {
  /** Its address: /docs/<slug>. The first page is /docs itself. */
  slug: string;
  title: string;
  group: string;
  Content: ComponentType;
}

/** Every docs page (M26), in the order the list shows them. */
export const DOC_PAGES: DocPage[] = [
  { slug: 'introduction', title: 'Introduction', group: 'Get started', Content: Introduction },
  { slug: 'install', title: 'Install the CLI', group: 'Get started', Content: Install },
  { slug: 'first-game', title: 'Your first game', group: 'Get started', Content: FirstGame },
  { slug: 'manifest', title: 'mogzo.json', group: 'Get started', Content: Manifest },
  { slug: 'ai-tools', title: 'AI coding tools', group: 'Get started', Content: AiTools },
  { slug: 'sdk', title: 'The SDK', group: 'Game Services', Content: Sdk },
  { slug: 'cloud-saves', title: 'Cloud saves', group: 'Game Services', Content: CloudSaves },
  { slug: 'game-data', title: 'Game data', group: 'Game Services', Content: GameData },
  { slug: 'leaderboards', title: 'Leaderboards', group: 'Game Services', Content: Leaderboards },
  { slug: 'achievements', title: 'Achievements', group: 'Game Services', Content: Achievements },
  { slug: 'remote-config', title: 'Remote config', group: 'Game Services', Content: RemoteConfig },
  { slug: 'multiplayer', title: 'Multiplayer', group: 'Game Services', Content: Multiplayer },
  { slug: 'live-events', title: 'Live events', group: 'Game Services', Content: LiveEvents },
  { slug: 'splash', title: 'Splash and launch', group: 'Your game on MOGZO', Content: Splash },
  {
    slug: 'panels',
    title: 'MOGZO’s panels and Game UI',
    group: 'Your game on MOGZO',
    Content: Panels,
  },
  {
    slug: 'store-listing',
    title: 'Store listing',
    group: 'Your game on MOGZO',
    Content: StoreListing,
  },
  { slug: 'testing', title: 'Testing', group: 'Your game on MOGZO', Content: Testing },
  {
    slug: 'submitting',
    title: 'Submitting and publishing',
    group: 'Your game on MOGZO',
    Content: Submitting,
  },
  { slug: 'cli', title: 'CLI commands', group: 'Reference', Content: CliCommands },
  { slug: 'limits', title: 'Limits', group: 'Reference', Content: Limits },
  {
    slug: 'troubleshooting',
    title: 'When something goes wrong',
    group: 'Reference',
    Content: Troubleshooting,
  },
];

export const DOC_GROUPS = [...new Set(DOC_PAGES.map((page) => page.group))];

/** The old one-page docs' sections (/docs#saves), and where each went. */
export const OLD_ANCHORS: Record<string, string> = {
  install: 'install',
  'sign-in': 'first-game#sign-in',
  create: 'first-game#create',
  dev: 'first-game#play',
  upload: 'first-game#upload',
  manifest: 'manifest',
  sdk: 'sdk',
  splash: 'splash',
  saves: 'cloud-saves',
  data: 'game-data',
  leaderboards: 'leaderboards',
  achievements: 'achievements',
  panels: 'panels',
  'ai-tools': 'ai-tools',
  config: 'remote-config',
  listing: 'store-listing',
  submit: 'submitting',
  limits: 'limits',
  trouble: 'troubleshooting',
};
